module.exports = __webpack_public_path__ + "static/img/greenbaoxiuSever.b2b5775.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/xinyuan/greenbaoxiuSever.png
// module id = Jcst
// module chunks = 0